import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
    key: 0,
    class: "week-list__delivery-items"
};
const _hoisted_3 = { class: "week-list__delivery-item-image" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "week-list__delivery-item-sku" };
const _hoisted_6 = { class: "week-list__delivery-item-quantity" };
const _hoisted_7 = { class: "week-list__delivery-item-name" };
const _hoisted_8 = { class: "week-list__delivery-item-view" };
const _hoisted_9 = { key: 0 };
import { ref, computed } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import ProductUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
const initialItemsNum = 3;
export default /*@__PURE__*/ _defineComponent({
    __name: 'PendingOrdersListSection',
    props: {
        day: {},
        deliveries: {}
    },
    setup(__props) {
        const props = __props;
        const items = computed(() => {
            const items = [];
            props.deliveries.forEach(delivery => {
                delivery.items.forEach(item => {
                    items.push({
                        sku: item.sku,
                        deliveryId: delivery.id,
                        quantity: item.quantity,
                        quantityUnit: item.quantityUnit,
                        name: item.name,
                        image: image(item),
                    });
                });
            });
            return items;
        });
        const expanded = ref(false);
        const visibleItems = computed(() => {
            if (items.value.length <= initialItemsNum || expanded.value) {
                return items.value;
            }
            return items.value.slice(0, initialItemsNum);
        });
        function image(item) {
            if (!item.image) {
                return null;
            }
            return ProductUtils.createImage(item.image);
        }
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "week-list__day-name",
                    title: _ctx.$date(__props.day.date)
                }, _toDisplayString(__props.day.name), 9, _hoisted_1),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (visibleItems.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item, i) => {
                            return (_openBlock(), _createBlock(_component_RouterLink, {
                                to: { name: 'deliveries_delivery', params: { id: item.deliveryId } },
                                key: i,
                                class: "week-list__delivery-item"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_3, [
                                        (item.image)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: item.image.url,
                                                alt: ""
                                            }, null, 8, _hoisted_4))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.sku), 1),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.quantity) + " " + _toDisplayString(_ctx.$te("unit." + item.quantityUnit) ? _ctx.$t("unit." + item.quantityUnit) : item.quantityUnit), 1),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(Icon, { name: "eye" })
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["to"]));
                        }), 128)),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        (items.value.length > initialItemsNum)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("a", {
                                    key: "show-more-toggle",
                                    href: "",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (expanded.value = !expanded.value), ["prevent"])),
                                    class: "week-list__show-more"
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(expanded.value ? _ctx.$t('watchlist.show-less') : _ctx.$t('watchlist.show-more')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
